<!-- Entry Heading -->
<h1 *ngIf="pageTitle" class="dt-page__title" [innerHTML]="pageTitle"></h1>
<!-- /entry heading -->

<ng-content></ng-content>
